import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import env from 'runtime.env';

const Component = ({ path, isS3 }) => (
  <Helmet>
    <link
      rel="icon"
      type="image/png"
      href={isS3 ? `${env.RT_S3_ASSETS}${path}` : path}
      sizes="16x16"
    />
  </Helmet>
);

Component.propTypes = {
  path: PropTypes.string.isRequired,
  isS3: PropTypes.bool,
};

Component.defaultProps = {
  isS3: false,
};

export default Component;
